import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DynamicTable from "../../../components/dynamicTable";

const tableHeader = ["Updated At", "Edited By", "Message"];

const displayRows = ["logs_changed_date", "changedBy", "message"];

const Logs = ({ allData }) => {
  const [allLogs, setAllLogs] = useState([]);

  useEffect(() => {
    if (!allData || !Array.isArray(allData)) {
      return;
    }
  
  
    const sortedLogs = [...allData].sort((a, b) => 
      new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
  
  
    setAllLogs(sortedLogs);
  }, [allData]);


  return (
    <Box my={3}>
      <Typography variant="h6" color={"text.charcoalGrey"} mb={3}>
        Logs
      </Typography>

      <DynamicTable
        tableData={allLogs || []}
        displayRows={displayRows}
        tableHeader={tableHeader}
      />
    </Box>
  );
};

export default Logs;
